import { render, staticRenderFns } from "./MultipleUploadImage.vue?vue&type=template&id=bd27892a&scoped=true&"
import script from "./MultipleUploadImage.vue?vue&type=script&lang=js&"
export * from "./MultipleUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./MultipleUploadImage.vue?vue&type=style&index=0&id=bd27892a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd27892a",
  null
  
)

export default component.exports